export const calculateDifference = (
  evTotal: number, petrolTotal: number,
) => {
  return evTotal - petrolTotal;
};
